import { createAsyncThunk } from '@reduxjs/toolkit'

import type { RootState } from 'redux/store/RootReducer'
import type { AppDispatch } from 'redux/store'
import filterGroupsAPI from 'api/ApiActions/Groups/FilterByGroup'

export const fetchParticipantGroups: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>(
  'participant/fetchParticipantGroups',
  async (groupPayload = {}, { rejectWithValue }) => {
    try {
      const response = await filterGroupsAPI.getGroups(groupPayload)

      return response?.data?.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
